import { AccessTime, DateRange, LocationCity } from '@mui/icons-material';
import { Button } from '@mui/material';
import { isAfter, isBefore, isSameDay } from 'date-fns';
import { useTranslation } from 'next-i18next';
import { EventInterface } from '../../../../../../interfaces/interfaces';
import { createDisplayLink, formatUTCDate } from '../../../../../../services/helper';
import Link from 'next/link';

const EventsListItem = ({
  event,
  buttonColor,
  textColor,
  buttonText,
  showEndTime,
}: {
  event: EventInterface;
  buttonColor?: string;
  textColor?: string;
  buttonText?: string;
  showEndTime?: boolean;
}) => {
  const { t } = useTranslation();
  const hasLogo = !!event.template?.logo;
  const multiDayEvent = !isSameDay(new Date(event.datetime_start), new Date(event.datetime_end));

  return (
    <div
      className="w-full @lg:h-48 @lg:overflow-scroll bg-white flex flex-col @lg:flex-row justify-between items-center @lg:items-start p-2"
      style={{ borderRadius: '4px' }}>
      {hasLogo && <img className="@md:w-1/6 object-contain p-5" src={createDisplayLink(event.template?.logo)} alt={event.name} />}
      <div className={`${hasLogo ? '@md:w-3/6' : ''} flex flex-col space-y-2 py-4`}>
        <p className="text-2xl text-center @lg:text-left">{event.name}</p>
        <div className="flex flex-row flex-wrap  @lg:space-x-2 ">
          <div className="flex flex-row items-center space-x-1">
            <DateRange color="primary" fontSize="small" />
            <p>{formatUTCDate(new Date(event.datetime_start), 'dd.MM.yyyy')}</p>
          </div>

          <div className="flex flex-row space-x-1 mx-2 @lg:mx-0 items-center">
            <AccessTime color="primary" fontSize="small" />
            <p>{formatUTCDate(new Date(event.datetime_start), 'HH:mm')}</p>
          </div>

          {showEndTime && (
            <div className="flex flex-row flex-wrap  @lg:space-x-2 ">
              <p className="mx-2">{t('account:to')}</p>
              {multiDayEvent && (
                <div className="flex flex-row items-center space-x-1">
                  <DateRange color="primary" fontSize="small" />
                  <p>{formatUTCDate(new Date(event.datetime_end), 'dd.MM.yyyy')}</p>
                </div>
              )}

              <div className="flex flex-row space-x-1 mx-2 @lg:mx-0 items-center">
                <AccessTime color="primary" fontSize="small" />
                <p>{formatUTCDate(new Date(event.datetime_end), 'HH:mm')}</p>
              </div>
            </div>
          )}

          {event.region && (
            <div className="flex flex-row items-center space-x-1">
              <LocationCity color="primary" fontSize="small" />
              <p>{event.region}</p>
            </div>
          )}
        </div>
        <p
          className="text-slate-400"
          dangerouslySetInnerHTML={{
            __html: event?.description ?? '',
          }}
        />
      </div>
      <div className="w-full @md:w-1/3 @lg:w-1/6 grid place-items-center">
        <Link target="_blank" className="w-full " href={`/event/${event.slug}/live`}>
          <Button color="primary" style={{ backgroundColor: buttonColor, color: textColor }} fullWidth>
            {buttonText || (
              <>
                {isAfter(new Date(), new Date(event.datetime_start)) && isBefore(new Date(), new Date(event.datetime_end))
                  ? t('account:to-live-event')
                  : t('account:open-event')}
              </>
            )}
          </Button>
        </Link>
      </div>
    </div>
  );
};
export default EventsListItem;
